<template>
  <el-table
    ref="sharedTable"
    v-loading="loading"
    class="mt-xl"
    header-row-class-name="table-header"
    :data="data"
    size="medium"
    border
    stripe
  >
    <el-table-column
      prop="stt"
      label="STT"
      align="center"
      width="80"
    >
      <template slot-scope="scope">
        {{ scope.row.stt }}
      </template>
    </el-table-column>
    <el-table-column
      prop="avartar"
      label=""
      align="center"
      width="80"
    >
      <template slot-scope="scope">
        <ImageDefault
          :src="scope.row.extra.file_images | avatarUrl(avatarData)"
          width="48px"
          height="48px"
        />
      </template>
    </el-table-column>
    <el-table-column
      v-for="(c, index) in columns"
      :key="index"
      :prop="c.key"
      :label="c.label"
      :align="c.column.align"
      :width="c.column.width"
      :min-width="c.column.min_width || '100px'"
    >
      <template slot-scope="scope">
        <ViewItem
          :field="c"
          :data="scope.row"
        />
      </template>
    </el-table-column>
    <el-table-column
      v-if="contract && contractTypeStatus !== 'none'"
      prop="stt"
      label="Trạng thái"
      align="center"
      min-width="300"
      fixed="right"
    >
      <template slot-scope="scope">
        <el-tag>
          {{ scope.row.contract_status[contract.contract_type] | statusName(allContractStatus) }}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column
      v-if="contract && contractTypeStatus !== 'none'"
      label="Lịch sử"
      min-width="250"
      fixed="right"
      align="center"
    >
      <template slot-scope="scope">
        <el-button
          type="primary"
          plain
          size="mini"
          @click="() => $emit('show', scope.row)"
        >
          Xem nhanh
        </el-button>
        <el-button
          type="primary"
          size="mini"
          @click="() => $emit('history', scope.row)"
        >
          Chi tiết
        </el-button>
      </template>
    </el-table-column>
    <el-table-column
      v-if="!!contract"
      label="Phê duyệt"
      width="100"
      fixed="right"
      align="center"
    >
      <template slot-scope="scope">
        <ContractActions
          :item="scope.row"
          :approved-data="approvedData"
          :contract="contract"
          @request="(v) => $emit('request', scope.row, v)"
        />
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { mapGetters } from "vuex";
import ImageDefault from "@/components/items/ImageDefault.vue";
import ContractActions from "@/components/items/ContractActions.vue";
import ViewItem from "@/components/items/ViewItem.vue";
import constants from "@/config/constants";

export default {
  name: "CardList",
  components: {
    ImageDefault,
    ContractActions,
    ViewItem
  },
  props: {
    config: Object,
    data: Array,
    approvedData: Array,
    avatarData: Array,
    loading: Boolean,
    contract: Object,
    contractTypeStatus: String
  },
  data() {
    return {
      fieldType: constants.FIELD_TYPE,
    };
  },
  computed: {
    ...mapGetters("contract", ["allContracts", "allContractStatus"]),
    ...mapGetters("category", ["allCategories"]),
    columns() {
      const result = this.config.extra.fields;
      return result
        .filter((i) => i.show.column)
        .sort((a, b) => a.order - b.order);
    },
  },
  methods: {
  },
};
</script>

<style lang="scss"></style>
